import { reConcat } from "./regex";

export function isInPreviewIframe() {
    if (window.__SOFTR_E2E_ONLY_APP_MODE__ === "preview") {
        return true;
    }

    return window.parent !== window && isPreviewURL(new URL(window.location.href));
}

const PREVIEW_URL_REGEX = reConcat(/\.preview/, /(\.staging([\d]{2})?)?/, /\.softr\.app$/);
function isPreviewURL(url: URL) {
    return PREVIEW_URL_REGEX.test(url.hostname);
}

declare global {
    interface Window {
        __SOFTR_E2E_ONLY_APP_MODE__?: string;
    }
}

